import ProfessionalRetailerPopup from '@PagesComponent/Professional_RetailerPopup';
import { useRouter } from 'next/router'
import React, { useState, useEffect } from 'react'
import styled from 'styled-components';
import { useRef } from 'react';
import { LinkAnchor, refferalRouting } from '@Components/Common/CommonMethods';
const AffiliateShare = styled.div`
a{
    font-size: 20px;
    font-family: var(--exo);
    color: inherit;
}
.buton-dashboard{
    display: flex;
    gap: 26px;
    justify-content: center;
    text-decoration: underline;
}
.btn-affiliate.button_sections{
    display: flex;
    justify-content: center;
    gap: 12px;
}

`;
export default function index(props) {
    const router = useRouter();
    const [openPopup, setOpenPopup] = useState(false);
    const [loginToken, setLoginToken] = useState(false);

    function Affiliate() {
        if (loginToken) {
            router?.push("/us/user/become_affiliate/")
        }
        else {
            router?.push('/us/signup?d=is_affiliate')

        }
    }

    useEffect(() => {
        if (localStorage.getItem('Token')) {
            setLoginToken(true);
        } else {
            setLoginToken(false);
        }
    }, []);

    function handleOpenPopup() {
        document.body.classList.add('professional_retailer_form_popup');
        setOpenPopup(true)
    }

    //close popup after click outside

    const ref = useRef();
    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (ref.current && !ref.current.contains(e.target)) {

                setOpenPopup(false);
                document.body.classList.remove('professional_retailer_form_popup');
                //   onClose()
            }
        }
        document.addEventListener("click", checkIfClickedOutside)
        return () => {
            document.removeEventListener("click", checkIfClickedOutside)
        }
    }, [openPopup])

    return (
        <AffiliateShare>
            <div className='become-affiliate' ref={ref}>
                <div className='container'>
                    <div className='produccts-share'>
                        <h2>Love SN<span className='small-letter-span'>i</span>P?</h2>
                    </div>
                    <div className='affiliates-earn common-heading'>
                        <p><strong>Tell the world and receive more than thanks.</strong></p>
                    </div>

                    <div className='Scenario-1 common-heading d-flex'>
                        <div className='img-scenario-1 d-flex'>
                            <div className='cotnainer-left'>
                                <h3>1</h3>
                            </div>
                            <div className='cotnainer-img'>
                                <h3>Love</h3>
                                <img src='/images/like.jpg' />
                                {/* <span>Enroll</span> */}
                            </div>
                        </div>

                        <div className='img-scenario-2 d-flex'>
                            <div className='cotnainer-left'>
                                <h3>2</h3>
                            </div>
                            <div className='cotnainer-img'>
                                <h3>Share</h3>
                                <img src='/images/share.jpg' />
                                {/* <span>Share your affiliate link</span> */}
                            </div>
                        </div>
                        <div className='img-scenario-3 d-flex'>
                            <div className='cotnainer-left'>
                                <h3>3</h3>
                            </div>
                            <div className='cotnainer-img'>
                                <h3>Earn</h3>
                                <img src='/images/earn.jpg' />
                                {/* <span>Earn 25% on referral sales, or
                                    $37.25 per order of
                                    personalized nutrition.</span> */}
                            </div>
                        </div>
                    </div>
                    <div className='Scenario-2 common-heading'>

                        {/* <p>In-the-know with wellness professionals or natural products retailers?
                            Your personal referral earns you 5% on their sales.</p> */}
                        <div className='btn-affiliate button_sections'>
                            <LinkAnchor href={refferalRouting('/us/affliateshare/affiliate_form/')}>
                                <button className='btn-primary-btn'>LEARN MORE</button>
                            </LinkAnchor>

                            <button className='btn-primary-btn' onClick={() => Affiliate()}>{!loginToken ? "JOIN NOW" : "BECOME AN AFFILIATE"}</button>

                            {/* <button className='btn-primary-btn' style={{ margin: '10px' }}>
                                <a style={{ color: '#fff' }} href='https://admin.snipnutrition.com/media/documents/SNIP_Affiliate_Document_050124.pdf'
                                    target='_blank'>Affiliate Program</a>
                            </button> */}
                        </div>

                        <div className='btn-affiliate-toolkit'>
                            <p>Already an affiliate?</p>
                            <div className='buton-dashboard'>
                                <a href='/us/login'>Dashboard Log In</a>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div className='paid-weekly'>
                        <p> *Paid (weekly) on personal nutritional products only.</p>
                    </div>
                </div>
                {openPopup && <ProfessionalRetailerPopup open={openPopup} setOpen={setOpenPopup} section="affiliate" plan="SNiP affiliate" />}
            </div>
        </AffiliateShare>
    )
}
